// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as SurchargeUtils$OrcaPaymentPage from "./SurchargeUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function Surcharge(props) {
  var __isForWallets = props.isForWallets;
  var __cardBrand = props.cardBrand;
  var paymentMethod = props.paymentMethod;
  var cardBrand = __cardBrand !== undefined ? __cardBrand : "NOTFOUND";
  var isForWallets = __isForWallets !== undefined ? __isForWallets : false;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var getPaymentMethodTypes = function (paymentMethodType) {
    return Core__Option.getOr(PaymentMethodsRecord$OrcaPaymentPage.getPaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, PaymentUtils$OrcaPaymentPage.getPaymentMethodName(paymentMethod, paymentMethodType)), PaymentMethodsRecord$OrcaPaymentPage.defaultPaymentMethodType);
  };
  var paymentMethodTypes = getPaymentMethodTypes(props.paymentMethodType);
  var getOneClickWalletsMessage = SurchargeUtils$OrcaPaymentPage.useOneClickWalletsMessageGetter(paymentMethodListValue);
  var getSurchargeUtilsMessage = SurchargeUtils$OrcaPaymentPage.useMessageGetter();
  var getSurchargeMessage = function () {
    if (isForWallets) {
      return getOneClickWalletsMessage();
    }
    var surchargeDetails = paymentMethodTypes.surcharge_details;
    if (surchargeDetails !== undefined) {
      return getSurchargeUtilsMessage(surchargeDetails, paymentMethod, paymentMethodListValue);
    }
    if (paymentMethod !== "card") {
      return ;
    }
    var creditPaymentMethodTypes = getPaymentMethodTypes("credit");
    var debitCardNetwork = PaymentMethodsRecord$OrcaPaymentPage.getCardNetwork(paymentMethodTypes, cardBrand);
    var creditCardNetwork = PaymentMethodsRecord$OrcaPaymentPage.getCardNetwork(creditPaymentMethodTypes, cardBrand);
    var match = debitCardNetwork.surcharge_details;
    var match$1 = creditCardNetwork.surcharge_details;
    if (match === undefined) {
      if (match$1 !== undefined) {
        return getSurchargeUtilsMessage(match$1, paymentMethod, paymentMethodListValue);
      } else {
        return ;
      }
    }
    if (match$1 === undefined) {
      return getSurchargeUtilsMessage(match, paymentMethod, paymentMethodListValue);
    }
    var creditCardSurcharge = match$1.displayTotalSurchargeAmount;
    var debitCardSurcharge = match.displayTotalSurchargeAmount;
    if (creditCardSurcharge >= debitCardSurcharge) {
      return getSurchargeUtilsMessage(match$1, paymentMethod, paymentMethodListValue);
    } else {
      return getSurchargeUtilsMessage(match, paymentMethod, paymentMethodListValue);
    }
  };
  var surchargeMessage = getSurchargeMessage();
  if (surchargeMessage !== undefined) {
    return React.createElement("div", {
                className: "flex items-baseline text-xs mt-2"
              }, React.createElement(Icon$OrcaPaymentPage.make, {
                    name: "asterisk",
                    size: 8,
                    className: "text-red-600 mr-1"
                  }), React.createElement("div", {
                    className: "text-left text-gray-400"
                  }, Caml_option.valFromOption(surchargeMessage)));
  } else {
    return null;
  }
}

var make = Surcharge;

export {
  make ,
}
/* react Not a pure module */
